import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';

export type IChipProps = MuiChipProps & {
    name: string;
};

export const Chip = ({ variant = 'outlined', ...rest }: IChipProps) => (
    <MuiChip data-testid={`chip-${rest.name}`} {...rest} variant={variant} />
);
